import React, { FC } from 'react';
import styled from '@emotion/styled';
import OrderNumberSlipDesign from './OrderNumberSlipDesign';
import useOrderNumberSlipPrint from './useOrderNumberSlipPrint';

/** Off-screen host for the slip while html-to-image rasterizes it (same trick as BongMaster). */
const SlipWrapper = styled.div`
  position: fixed;
  pointer-events: none;
  opacity: 0;
  width: 300px;
`;

interface Props {
  /**
   * The order id this kiosk session is currently placing. state.POSReceiptPrints is a
   * single global slot that is never cleared after use (see CLEAR_RECEIPT), so without
   * this guard a fresh kiosk session that remounts this component would immediately
   * reprint whatever order-number ticket a previous, unrelated session last queued here.
   */
  orderId: string | null;

  /** EPOS only: an extra line printed under the QR code, already run through i18n. */
  extraMessage?: string;

  /** EPOS only: printed as a QR code between the order number and extraMessage. No QR when unset. */
  qrCodeLink?: string | null;
}

const OrderIdMaster: FC<Props> = ({ orderId, extraMessage, qrCodeLink }) => {
  const slipPrint = useOrderNumberSlipPrint({ orderId, extraMessage });

  if (!slipPrint.pendingOrderNumber) {
    return null;
  }

  // The ref sits on a plain inner div, exactly like BongMaster: the fixed/opacity-0 wrapper is
  // never cloned by html-to-image, which otherwise can produce an empty image.
  return (
    <SlipWrapper>
      <div ref={slipPrint.slipRef}>
        <OrderNumberSlipDesign
          orderNumber={slipPrint.pendingOrderNumber}
          extraMessage={extraMessage}
          qrCodeLink={qrCodeLink}
        />
      </div>
    </SlipWrapper>
  );
};

export default OrderIdMaster;
